import * as React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Img, WmkImage } from "wmk-image";
import Theme from "../../../../vars/ThemeOptions";
import SubHeading from "../../../common/typography/SubHeading";
import ReactMarkdown from "react-markdown";
import { Fade } from "react-awesome-reveal";
import { Parallax } from "react-scroll-parallax";
import styled from "styled-components";

const StyledParallax = styled.div`
  .gatsby-image-wrapper {
    width: 130%;
  }
`;

const CaseStudyItemContainer = styled(Container)<{ isresults: string }>`
  .image-col {
    order: 2;
  }
  .text-col {
    order: 1;
  }
  strong {
    font-weight: 700;
  }
  @media screen and (max-width: 767px) {
    ${({ isresults }) => {
      return isresults
        ? ""
        : `.image-col {
            order: 1;
          }
          .text-col {
            order: 2;
          }`;
    }}
  }
`;

type CaseStudyImageTextProps = {
  displayStyle: "Columns" | "Rows";
  image: Img;
  mediaEffect: "None" | "Slide In Up" | "Parallax Right";
  title: string;
  text: string;
};

const CaseStudyImageText = ({
  displayStyle,
  image,
  mediaEffect,
  title,
  text,
}: CaseStudyImageTextProps) => {
  return (
    <CaseStudyItemContainer
      fluid
      style={{ padding: 0, margin: 0 }}
      isresults={title === "Results" ? "true" : ""}
    >
      <Row
        className={displayStyle === "Rows" ? "flex-column" : undefined}
        style={{
          marginTop: 0,
          marginBottom: displayStyle === "Columns" && image.src ? "-6rem" : 0,
          position: "relative",
          zIndex: 0,
        }}
      >
        <Col
          style={{
            marginBottom: displayStyle === "Rows" && image.src ? "-4rem" : 0,
            position: "relative",
            zIndex: 10,
          }}
          className="text-col"
        >
          <Container style={{ borderLeft: `solid 4px ${Theme.hex("fire")}` }}>
            <Row className="flex-column">
              {title ? (
                <Col>
                  <SubHeading text={title} />
                </Col>
              ) : null}
              <Col style={{ paddingBottom: !image.src ? 0 : "8rem" }}>
                <ReactMarkdown
                components={{
                  a: ({node, ...props}) => <a href={props.href} target="_blank"> {props.children} </a>
                }}
                >{text}</ReactMarkdown>
              </Col>
            </Row>
          </Container>
        </Col>
        {image.src ? (
          <Col
            style={{
              padding: 0,
              margin: displayStyle === "Rows" && image.src ? "0 0 -3rem 0" : 0,
              display: "flex",
              alignItems: "center",
              zIndex: -1,
            }}
            sm={title === "Results" ? "auto" : 12}
            md={title === "Results" ? "auto" : 6}
            className="image-col"
          >
            {mediaEffect === "Slide In Up" ? (
              <Fade direction="up" duration={2000} triggerOnce>
                <WmkImage image={image} style={{ padding: `1rem 0` }} />
              </Fade>
            ) : mediaEffect === "Parallax Right" ? (
              <Parallax translateX={[-30, 0]}>
                <StyledParallax>
                  <WmkImage
                    className="parallax"
                    image={image}
                    style={{ padding: `1rem 0` }}
                  />
                </StyledParallax>
              </Parallax>
            ) : (
              <WmkImage image={image} />
            )}
          </Col>
        ) : null}
      </Row>
    </CaseStudyItemContainer>
  );
};

export default CaseStudyImageText;
